import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Router, RouterProvider } from "react-router";
import App from './App';
import { AppRouter } from './routing/routes';
import { AuthServiceProvider } from './shared/authservice';
import { EchoProvider } from './shared/echo';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthServiceProvider>
        <EchoProvider>
          <AppRouter />
        </EchoProvider>
      </AuthServiceProvider>
    </BrowserRouter>
  </React.StrictMode>
);
